/**
 * Extends a JS Promise by adding some status properties
 * @param {Promise} promise Promise object to extend
 *
 * @returns {Promise}
 */
export default function querablePromise(promise) {
  // Don't modify any promise that has been already modified.
  if (promise.isResolved) return promise;

  // Set initial state
  let isPending = true;
  let isRejected = false;
  let isResolved = false;

  // Observe the promise, saving the fulfillment in a closure scope.
  const result = promise.then(
    (v) => {
      isResolved = true;
      isPending = false;
      return v;
    },
    (e) => {
      isRejected = true;
      isPending = false;
      throw e;
    },
  );

  result.isResolved = () => isResolved;
  result.isPending = () => isPending;
  result.isRejected = () => isRejected;

  return result;
}
